import { render, staticRenderFns } from "./VStatsBox.vue?vue&type=template&id=3fc72696"
import script from "./VStatsBox.vue?vue&type=script&lang=js"
export * from "./VStatsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports